import { AuthModel } from './_models';
import IUserService from 'src/app/services/user/service';

export interface DataMenuAuthGuard {
  title: string;
  roles: string[];
  bidang: string | null;
  sub_bidang: string | null;
  subItems?: DataMenuAuthGuard[];
  link?: string;
  icon?: string;
}

export interface CheckGuardProtectionParams {
  guards: string[];
  subItems?: DataMenuAuthGuard[];
  bidang?: string | null;
  subBidang?: string | null;
  title: string;
}

/**
 * checkGuardProtection.
 * @param {CheckGuardProtectionParams} param0
 * @param {AuthModel} auth
 * @returns {boolean}
 */
export const checkGuardProtection = (
  { title, guards, bidang, subBidang, subItems }: CheckGuardProtectionParams,
  auth: AuthModel
): boolean => {
  const { role, nama_bidang, nama_sub_bidang } = auth.user;

  const titleSubMenu = subItems?.map((item) => {
    return item.title;
  }) || [];

  // Superadmin dan Admin bersifat global — akses semua menu tanpa perlu
  // tercantum di guards maupun mencocokkan bidang/sub_bidang.
  if (role === IUserService.SUPER_ADMIN || role === IUserService.ADMIN) {
    return true;
  }

  /* This configuration for all role to access dashboard menu */
  if (
    role === IUserService.ADMIN_BPHTB ||
    role === IUserService.ADMIN_PBB ||
    role === IUserService.KABID ||
    role === IUserService.KASUBBID ||
    role === IUserService.KECAMATAN ||
    role === IUserService.KELURAHAN ||
    role === IUserService.NOTARIS ||
    role === IUserService.OPERATOR ||
    role === IUserService.PENATAAN_PBB ||
    role === IUserService.PETUGAS_LAPANGAN ||
    role === IUserService.ADMIN_KOLEKTOR ||
    role === IUserService.KOLEKTOR ||
    role === IUserService.SURVEI_BPHTB
  ) {
    if (title === 'Global Menu' && titleSubMenu.includes('Dashboard')) {
      return true;
    }
  }

  if (guards.includes(role)) {
    // Jika menu tidak memiliki bidang (menu umum)
    if (!bidang) {
      return true;
    }
    
    // Jika menu memiliki bidang, cek apakah sesuai dengan bidang user
    if (
      bidang &&
      nama_bidang &&
      bidang.includes(nama_bidang)
    ) {
      // Jika ada sub_bidang di menu, pastikan juga sesuai
      if (subBidang && nama_sub_bidang && !subBidang.includes(nama_sub_bidang)) {
        return false;
      }
      return true;
    }
  }

  if (role === IUserService.NOTARIS) {
    if (guards.includes(role) && !bidang && !subBidang) {
      return true;
    }
  }

  if (role === IUserService.ADMIN_KOLEKTOR) {
    if (guards.includes(role) && !bidang && !subBidang) {
      return true;
    }
  }

  if (role === IUserService.KOLEKTOR) {
    if (guards.includes(role) && !bidang && !subBidang) {
      return true;
    }
  }

  if (role === IUserService.PETUGAS_LAPANGAN) {
    if (guards.includes(role) && !bidang && !subBidang) {
      return true;
    }
  }
  if (role === IUserService.KECAMATAN) {
    if (guards.includes(role) && !bidang && !subBidang) {
      return true;
    }
  }
  if (role === IUserService.KELURAHAN) {
    if (guards.includes(role) && !bidang && !subBidang) {
      return true;
    }
  }

  if (role === IUserService.SURVEI_BPHTB) {
    if (guards.includes(role) && bidang && subBidang) {
      return true;
    }
  }

  // Jika menu ini sendiri ditolak, CEK APAKAH ADA SUB-MENU NYA YANG DIIZINKAN.
  // Jika ada salah satu sub-menu yang diizinkan, maka parent-nya OTOMATIS diizinkan.
  // Ini memenuhi fitur: "jika ada salah satu sub menu yang diaktifkan maka, parentnya otomatis aktif juga"
  if (subItems && subItems.length > 0) {
    const isAnyChildAllowed = subItems.some((child) => 
      checkGuardProtection(
        {
          title: child.title,
          guards: child.roles || [],
          bidang: child.bidang,
          subBidang: child.sub_bidang,
          subItems: child.subItems,
        },
        auth
      )
    );
    if (isAnyChildAllowed) {
      return true;
    }
  }

  return false;
};
